import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Store } from "react-notifications-component";
import LoginAPIvalidation from "./LoginAPIvalidation";
import "./Login.css";
import { OtpInput } from "reactjs-otp-input";
import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function ForgotPassword() {
  const { RendomTokenfetch } = useAuth();
  const navigate = useNavigate();

  const [error, setError] = useState({});

  const notification = {
    // message: "teodosii@react-notifications-component",
    insert: "top",
    container: "bottom-center",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 1000,
      showIcon: true,
      onScreen: true,
    },
  };

  const handleKeyPress = (e) => {
    const charCode = e.which || e.keyCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const [ClickOTPpassword, setClickOTPpassword] = useState(false);
  const handalBackBTN = () => {
    setClickOTPpassword(ClickOTPpassword === false ? true : false);
  };

  const [UserNumber, setUserNumber] = useState("");
  const [SentOTP, setSentOTP] = useState("");
  const [ChangePWD, setChangePWD] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleUsernumber = (e) => {
    setUserNumber(e.target.value);
  };

  const handleOTP = (SentOTP) => setSentOTP(SentOTP);

  const handleChangePWD = (e) => {
    setChangePWD(e.target.value);
  };

  const handleOtpSentSubmit = (event) => {
    event.preventDefault();
    let fdata = new FormData();
    fdata.append("number", UserNumber);
    axios
      .post(`${WebsiteAPIurl}forgotsendotp`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // console.log(response.data);
        if (UserNumber) {
          if (response.data.Status === "1") {
            Store.addNotification({
              ...notification,
              title: response.data.msg,
              type: "success",
            });

            // window.localStorage.setItem(
            //   "userid",
            //   response.data.userdata.userid
            // );
            setClickOTPpassword(true);
          }
          if (response.data.Status === "0") {
            Store.addNotification({
              ...notification,
              title: response.data.msg,
              type: "danger",
            });
          }
        } else {
          setError(LoginAPIvalidation(response.data.form_validation));
        }
      });
    // .catch((error) => {
    //   alert(error);
    // });
  };

  const handleChangePWDSubmit = (event) => {
    event.preventDefault();
    let fdata = new FormData();
    fdata.append("number", UserNumber);
    fdata.append("otp", SentOTP);
    fdata.append("password", ChangePWD);
    axios
      .post(`${WebsiteAPIurl}forgotsendotpverify`, fdata, {
        headers: {
          Authorization: RendomTokenfetch,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        // console.log(response.data);
        if (SentOTP && ChangePWD) {
          if (response.data.Status === "1") {
            Store.addNotification({
              ...notification,
              title: response.data.msg,
              type: "success",
              onRemoval: () => {
                navigate("/login");
                // window.location.reload();
              },
            });

            // window.localStorage.setItem(
            //   "userid",
            //   response.data.userdata.userid
            // );
          }
          if (response.data.Status === "0") {
            Store.addNotification({
              ...notification,
              title: response.data.msg,
              type: "danger",
            });
          }
        } else {
          setError(LoginAPIvalidation(response.data.form_validation));
        }
      });
    // .catch((error) => {
    //   alert(error);
    // });
  };

  return (
    <>
      <Helmet>
        <title>{"Forgot Password"}</title>
        <link rel="canonical" href={window.location.href} />
        <meta name="robots" content="index, follow"></meta>
      </Helmet>
      <section className="login-section section_padding_top bgc-home20">
        <div className="login-form default-form login_page_form">
          <div className="form-inner">
            <h3>Forgot Password Using OTP</h3>

            {ClickOTPpassword === false ? (
              <>
                <form onSubmit={handleOtpSentSubmit}>
                  <div className="form-group">
                    <label>
                      Enter Mobile Number<span className="text-danger">*</span>
                    </label>
                    <div className="otpganratebox">
                      <input
                        className="form-controll"
                        type="text"
                        name="number"
                        value={UserNumber || ""}
                        onChange={handleUsernumber}
                        onKeyPress={handleKeyPress}
                        maxLength={10}
                        inputMode="numeric"
                      />
                    </div>
                    {error.number && (
                      <span className="text-danger">* {error.number}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <button
                      className="theme-btn btn-style-one"
                      type="submit"
                      name="submit"
                    >
                      Send OTP
                    </button>
                  </div>
                </form>
                {localStorage.getItem("userid") ? (
                  ""
                ) : (
                  <div className="bottom-box text-center d-block">
                    <div className="text">
                      <Link to="/login">
                        <i
                          className="fa fa-angle-double-left"
                          aria-hidden="true"
                        ></i>{" "}
                        BACK TO LOGIN{" "}
                      </Link>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <form onSubmit={handleChangePWDSubmit}>
                  {/* <div className="text-center"> <span>A code has been sent to</span> <small id="maskedNumber">*******9897</small> </div> */}
                  <div className="form-group">
                    <label>
                      Enter OTP<span className="text-danger">*</span>
                    </label>
                    <OtpInput
                      value={SentOTP || ""}
                      onChange={(value) => {
                        const numericValue = value.replace(/\D/g, "");
                        handleOTP(numericValue);
                      }}
                      numInputs={6}
                      separator={<span>-</span>}
                      isInputNum={true}
                      shouldAutoFocus={true}
                      className="otpinputStyle"
                      renderInput={(props) => (
                        <input
                          {...props}
                          type="number"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          onKeyDown={(event) => {
                            if (
                              !/[0-9]/.test(event.key) &&
                              event.key !== "Backspace"
                            ) {
                              event.preventDefault();
                            }
                          }}
                        />
                      )}
                    />
                    {error.otp && (
                      <span className="text-danger">* {error.otp}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label>
                      Change Password<span className="text-danger">*</span>
                    </label>
                    <input
                      id="password-field"
                      type={showPassword ? "text" : "password"}
                      name="changepassword"
                      value={ChangePWD || ""}
                      onChange={handleChangePWD}
                    />
                    <span
                      onClick={togglePasswordVisibility}
                      className="paaswordshowhide"
                    >
                      {showPassword ? (
                        <i className="fa fa-eye" aria-hidden="true"></i>
                      ) : (
                        <i className="fa fa-eye-slash" aria-hidden="true"></i>
                      )}
                    </span>

                    {error.password && (
                      <span className="text-danger">* {error.password}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <button
                      className="theme-btn btn-style-one"
                      type="submit"
                      name="submit"
                    >
                      Change Password
                    </button>
                  </div>
                </form>
                <div className="bottom-box text-center d-block">
                  <div className="text">
                    <Link onClick={handalBackBTN}>
                      <i
                        className="fa fa-angle-double-left"
                        aria-hidden="true"
                      ></i>{" "}
                      BACK
                    </Link>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
